module.exports = __webpack_public_path__ + "files/3f55e8ade89028ef1a4fcc0430f79214.png";